var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(_vm.lazyLogo),expression:"lazyLogo"}],staticClass:"logoWrapper"}),_vm._m(0),_c('div',{staticClass:"d-flex flex-row justify-content-center"},[_c('b-spinner')],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',[_vm._v("Link wird abgerufen."),_c('br'),_vm._v("Bitte habe einen Moment Geduld.")])
}]

export { render, staticRenderFns }